import { render, staticRenderFns } from "./BillingPlanDetails.vue?vue&type=template&id=6dc67e10&scoped=true"
import script from "./BillingPlanDetails.vue?vue&type=script&lang=js"
export * from "./BillingPlanDetails.vue?vue&type=script&lang=js"
import style0 from "./BillingPlanDetails.vue?vue&type=style&index=0&id=6dc67e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc67e10",
  null
  
)

export default component.exports